import React from 'react';

import { Container } from './styles';

const Switch = ({ ...props }) => <Container {...props} />;

export default Switch;
